import React from 'react';
import { Typography, Button as MuiButton, ButtonProps } from '@mui/material';

export const DropdownCategoryTitle = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Typography
      sx={{
        fontSize: '0.65rem',
        fontWeight: 600,
        mb: 0.5,
        textTransform: 'uppercase',
        color: 'text.secondary',
        px: 0.75,
      }}
    >
      {children}
    </Typography>
  );
};

export const DropdownButton = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    isActive?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    sx?: ButtonProps['sx'];
  }
>(function DropdownButtonInner(
  { children, isActive, onClick, disabled, sx },
  ref
) {
  return (
    <MuiButton
      ref={ref}
      disabled={disabled}
      onClick={onClick}
      fullWidth
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 0.75,
        fontSize: '0.875rem',
        fontWeight: 500,
        color: disabled
          ? 'text.disabled'
          : isActive
            ? 'text.primary'
            : 'text.secondary',
        textAlign: 'left',
        bgcolor: isActive ? 'action.selected' : 'transparent',
        borderRadius: 1,
        textTransform: 'none',
        justifyContent: 'flex-start',
        '&:hover': {
          bgcolor: !disabled ? 'action.hover' : undefined,
          color: !disabled && !isActive ? 'text.primary' : undefined,
        },
        ...sx,
      }}
    >
      {children}
    </MuiButton>
  );
});
